export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7545.1b21b600.jpg";